import React from 'react';
import { Field } from 'formik';
import TextareaAutosize from 'react-textarea-autosize';
import clsx from 'clsx';

const Textarea = ({ autosize, id, name, className, ...props }) => {
  if (autosize) {
    return (
      <Field
        id={id}
        name={name}
        as={TextareaAutosize}
        minRows={props.minRows || 3}
        maxRows={undefined}
        className={clsx(
          'h-24 overflow-auto appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
          className,
        )}
        {...props}
      />
    );
  }

  return (
    <Field
      id={id}
      name={name}
      as="textarea"
      className={clsx(
        'h-24 overflow-auto appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
        className,
      )}
      {...props}
    />
  );
};

export default Textarea;
